import { ReactElement } from 'react'
import { Stack, Switch, Typography } from '@mui/material'

interface Props {
  isActiveErrors?: boolean
  setIsActiveErrors?: (isActive: boolean) => void

  isActiveWarnings?: boolean
  setIsActiveWarnings?: (isActive: boolean) => void
}

const ColoringProblems = ({
  isActiveErrors = false,
  setIsActiveErrors,
  isActiveWarnings = false,
  setIsActiveWarnings,
}: Props): ReactElement => {
  return (
    <>
      <Stack direction="row" alignItems="center">
        <Switch
          checked={isActiveErrors}
          onChange={event => {
            setIsActiveErrors?.(event.target.checked)
          }}
          size="small"
        />
        <Typography sx={{ p: 1 }} noWrap>
          Fehler
        </Typography>
      </Stack>
      <Stack direction="row" alignItems="center">
        <Switch
          checked={isActiveWarnings}
          onChange={event => {
            setIsActiveWarnings?.(event.target.checked)
          }}
          size="small"
        />
        <Typography sx={{ p: 1 }} noWrap>
          Warnungen
        </Typography>
      </Stack>
    </>
  )
}

export default ColoringProblems
